// Author Shi Wen Long
// Date 2024-12-27 14:09:54

class SithMesStoolPoSdr {
    constructor({
                    id = null,
                    projectCode = '',
                    startTime = '',
                    creator = '',
                    startDesc = '',
                    solution = '',
                    quantity = '',
                    poNumber = '',
                    itemNumber = '',
                    materialCode = '',
                    buyer = '',
                    vendorName = '',
                    vendor = '',
                    engineerName = '',
                    engineerCode = '',
                    engineerDesc = '',
                    handleTime = '',
                    type = '',
                    poReport = '',
                    engineerReport = '',
                    remark = '',
                    poReportList = '',
                    engineerReportList = ''
                }
                        = {}) {
        this.id = id;
        this.projectCode = projectCode;
        this.startTime = startTime;
        this.creator = creator;
        this.startDesc = startDesc;
        this.solution = solution;
        this.quantity = quantity;
        this.poNumber = poNumber;
        this.itemNumber = itemNumber;
        this.materialCode = materialCode;
        this.buyer = buyer;
        this.vendorName = vendorName;
        this.vendor = vendor;
        this.engineerName = engineerName;
        this.engineerCode = engineerCode;
        this.engineerDesc = engineerDesc;
        this.handleTime = handleTime;
        this.type = type;
        this.poReport = poReport;
        this.engineerReport = engineerReport;
        this.remark = remark;
        this.poReportList = poReportList;
        this.engineerReportList = engineerReportList;
    }
}

function newEntity() {
    return new SithMesStoolPoSdr();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'startTime',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.startTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'creator',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.creator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'startDesc',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.startDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'solution',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.solution',
            sortable: true,
            form: {
                type: 'select',
                options: [
                    {value: '0', text: '报废'},
                    {value: '1', text: '修复'},
                    {value: '2', text: '让步接收'}
                ]
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poNumber',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.poNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemNumber',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.itemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'material_bom',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'buyer',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.buyer',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorName',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.vendorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendor',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.vendor',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'engineerName',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.engineerName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'engineerCode',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.engineerCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'engineerDesc',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.engineerDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'handleTime',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.handleTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'type',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.type',
            sortable: true,
            form: {
                type: 'select',
                options: [
                    {value: '0', text: 'SDR'},
                    {value: '1', text: '技术澄清'}
                ]
            }
        },
        {
            key: 'materialShortText',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.materialShortText',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poReportList',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.poReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'engineerReportList',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.engineerReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.stool.sithMesStoolPoSdr.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    projectCodeFilter: '',
    startTimeRteFilter: '',
    startTimeLteFilter: '',
    creatorFilter: '',
    startDescFilter: '',
    solutionFilter: '',
    quantityFilter: '',
    poNumberFilter: '',
    itemNumberFilter: '',
    materialCodeFilter: '',
    buyerFilter: '',
    vendorNameFilter: '',
    vendorFilter: '',
    engineerNameFilter: '',
    engineerCodeFilter: '',
    engineerDescFilter: '',
    handleTimeRteFilter: '',
    handleTimeLteFilter: '',
    typeFilter: '',
    materialShortTextFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.startTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.startTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.creator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startDescFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.startDesc',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'solutionFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.solution',
        disabled: false,
        form: {
            type: 'select',
            options: [
                {value: '0', text: '报废'},
                {value: '1', text: '修复'},
                {value: '2', text: '让步接收'}
            ]
        }
    },
    {
        key: 'quantityFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.quantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumberFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.poNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemNumberFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.itemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.buyer',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.vendorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.vendor',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engineerNameFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.engineerName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engineerCodeFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.engineerCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engineerDescFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.engineerDesc',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'handleTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.handleTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'handleTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.handleTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'typeFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.type',
        disabled: false,
        form: {
            type: 'select',
            options: [
                {value: '0', text: 'SDR'},
                {value: '1', text: '技术澄清'}
            ]
        }
    },
    {
        key: 'materialShortTextFilter',
        label: 'label.sith.stool.sithMesStoolPoSdr.filter.materialShortText',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'projectCode',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTime',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.startTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creator',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.creator',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startDesc',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.startDesc',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'solution',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.solution',
        sortable: true,
        disabled: true,
        form: {
            type: 'select',
            options: [
                {value: '0', text: '报废'},
                {value: '1', text: '修复'},
                {value: '2', text: '让步接收'}
            ]
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumber',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.poNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemNumber',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.itemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyer',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.buyer',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorName',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.vendorName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendor',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.vendor',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engineerName',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.engineerName',
        sortable: true,
        disabled: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engineerCode',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.engineerCode',
        sortable: true,
        disabled: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engineerDesc',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.engineerDesc',
        sortable: true,
        disabled: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'handleTime',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.handleTime',
        sortable: true,
        disabled: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'type',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.type',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            options: [
                {value: '0', text: 'SDR'},
                {value: '1', text: '技术澄清'}
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poReportList',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.poReport',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'poReport'
        }
    },
    {
        key: 'engineerReportList',
        label: 'label.sith.stool.sithMesStoolPoSdr.entity.engineerReport',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'engineerReport'
        }
    }
]

export {
    SithMesStoolPoSdr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
